import Phaser from 'phaser';

export interface VolumeSlider {
  nodes: Phaser.GameObjects.GameObject[];
  destroy: () => void;
}

/** Honey track. Dragging sets a 0–1 level and leaves the on/off pill alone. */
export function addVolumeSlider(
  scene: Phaser.Scene,
  x: number,
  y: number,
  width: number,
  value: number,
  depth: number,
  onChange: (value: number) => void,
): VolumeSlider {
  const track = scene.add.graphics().setDepth(depth);
  const knob = scene.add.circle(x, y, 14, 0xf8c20e).setStrokeStyle(4, 0x6b3e22).setDepth(depth + 1);
  const hit = scene.add.rectangle(x + width / 2, y, width + 28, 48, 0x000000, 0.001).setDepth(depth + 2);
  hit.setInteractive({ useHandCursor: true });
  let level = clamp(value);

  const paint = () => {
    track.clear();
    track.fillStyle(0x3b2414, 1);
    track.fillRoundedRect(x, y - 7, width, 14, 7);
    track.fillStyle(0xf0c14a, 1);
    track.fillRoundedRect(x, y - 7, Math.max(14, width * level), 14, 7);
    knob.setPosition(x + width * level, y);
  };
  const at = (pointer: Phaser.Input.Pointer) => {
    const bounds = hit.getBounds();
    const inset = 14;
    level = clamp((pointer.worldX - (bounds.left + inset)) / Math.max(1, bounds.width - inset * 2));
    paint();
    onChange(level);
  };
  hit.on('pointerdown', (pointer: Phaser.Input.Pointer) => at(pointer));
  const move = (pointer: Phaser.Input.Pointer) => {
    if (!pointer.isDown || !hit.visible) return;
    const bounds = hit.getBounds();
    if (!bounds.contains(pointer.worldX, pointer.worldY) && !hit.input?.enabled) return;
    if (pointer.worldY < y - 40 || pointer.worldY > y + 40) return;
    if (pointer.worldX < x - 24 || pointer.worldX > x + width + 24) return;
    at(pointer);
  };
  scene.input.on('pointermove', move);
  paint();
  return {
    nodes: [track, knob, hit],
    destroy: () => {
      scene.input.off('pointermove', move);
      track.destroy();
      knob.destroy();
      hit.destroy();
    },
  };
}

function clamp(value: number): number {
  if (!Number.isFinite(value)) return 1;
  return Math.min(1, Math.max(0, value));
}
